import "@firebase/logger";

import "@firebase/util";

import "@firebase/webchannel-wrapper";

import "tslib";

import { b as e, u as r, Q as o } from "./prebuilt-e065c69d-7a321be7.js";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Prototype patches bundle loading to Firestore.
 */ function t(o) {
    o.prototype.loadBundle = e, o.prototype.namedQuery = r;
}

t(o);

export { t as registerBundle };
//# sourceMappingURL=bundle.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/firestore/dist/esm5/bundle.js
// module id = 529
// module chunks = 1